import React, { useState, useEffect } from "react";
import axios from "axios";
import { API, useAuth } from "@/App";
import { toast } from "sonner";
import { Bell, BellRing } from "lucide-react";
import { apiError } from "@/lib/apiError";

export const PriceAlertButton = ({ productId, requireLogin }) => {
  const { user, getAuthHeaders } = useAuth();
  const [on, setOn] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!user) return;
    axios.get(`${API}/alerts/${productId}`, { headers: getAuthHeaders() }).then((r) => setOn(r.data.subscribed)).catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productId, user]);

  const toggle = async () => {
    if (!user) return requireLogin(null, "Please login to get price-drop alerts for this product.");
    setBusy(true);
    try {
      const r = await axios.post(`${API}/alerts/${productId}`, {}, { headers: getAuthHeaders() });
      setOn(r.data.subscribed);
      toast.success(r.data.message);
    } catch (err) {
      toast.error(apiError(err, "Couldn't update price alert"));
    }
    setBusy(false);
  };

  return (
    <button
      type="button"
      onClick={toggle}
      disabled={busy}
      className={`inline-flex items-center gap-2 h-11 px-4 rounded-full text-sm font-bold border-2 transition-colors ${on ? "bg-secondary-500 border-secondary-500 text-primary-900" : "bg-white border-primary-200 text-primary-700 hover:border-primary-400"}`}
      aria-pressed={on}
      data-testid="price-alert-btn"
    >
      {on ? <BellRing className="w-4 h-4" /> : <Bell className="w-4 h-4" />}
      {on ? "Alert on" : "Alert me on price drop"}
    </button>
  );
};
